// Import CSS styles
import './errorboundary.scss';
import './utils.scss';

export * from './context';
// Exports explícitos para facilitar o uso
export { useArchbaseTranslation, archbaseI18next, getI18nextInstance } from './context/ArchbaseGlobalProvider';
export * from './exceptions';
export * from './helper';
export * from './hooks';
export * from './ioc';
export * from './json';
export * from './rsql/ast';
export * from './rsql/builder';
export * from './rsql/emitter';
export * from './rsql/parser';
export * from './utils';
export * from './types';
export * from './types/filter';
export * from './errorboundary';
export * from "./utils/masker";
// Export validator but avoid conflicts
export { ArchbaseValidator } from './validator/ArchbaseValidator';
export type { ValidationError, ValidatorOptions } from './validator';
export * from './validator';
export * from './locales';
// Marcação de capacidade nos controles — mora aqui, e não no @archbase/security, porque quem
// precisa dela são os componentes padrão (@archbase/components), e components não pode depender
// de security: a dependência é a outra. O @archbase/core é a base que todos já consomem.
export * from './security/marcacaoDeAcao';
export * from './fallback/ArchbaseSafeMigrationWrapper'

// Temporary export for migration compatibility
export function detectDataSourceVersion(dataSource: any): string {
  return dataSource?.version || 'v1';
}
export { ValidationErrorsProvider, useValidationErrors, useRequiredValidationErrors } from './validation/ValidationErrorsContext';
